
let _cache_key = {
    //城市
    city_name: 'city_name',

};


export default _cache_key
